/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

export type FabNumberFilterOperator = 'eq' | 'neq' | 'gte' | 'gt' | 'lte' | 'lt' | 'isempty' | 'isnotempty';

@Component({
  selector: 'rem-number-filter',
  templateUrl: './number-filter.component.html',
  styleUrls: ['../table-filter.component.scss'],
})
export class RemNumberFilterComponent {
  static nextId = 0;

  /** Operators for the filter. Filter menu displays operators based on this array input */
  @Input()
  public operators: FabNumberFilterOperator[] = ['eq', 'gte', 'lte'];

  /** Column definition for the current column */
  @Input()
  public columnDef: string;

  /** Emits change in filter criteria */
  @Output()
  public filterChange = new EventEmitter();

  public filterIsSelected = false;
  public operator = new UntypedFormControl();
  public nextInstance = RemNumberFilterComponent.nextId;
  public value = new UntypedFormControl();

  constructor() {
    // increment nextId
    RemNumberFilterComponent.nextId++;
    // set the current value of the first operator
    this.operator.setValue('eq');
  }

  /**
   * clear the filter criteria
   * removed filter selection and sets it to false
   * sets the filter default value
   * emits the filter change event
   * */
  public clearFilter(): void {
    this.filterIsSelected = false;
    this.operator.setValue('eq');
    this.value.setValue(null);
    const currentFilter = [{ field: this.columnDef, operator: 'clear', value: this.value.value }];
    this.filterChange.emit(currentFilter);
  }

  /**
   * get index of the operators
   * */
  public getIndex(item: any): boolean {
    return this.operators.indexOf(item) !== -1;
  }

  /**
   * sets the filter and highlights the selection to true
   * emits the filter change event
   * */
  public setFilter(): void {
    this.filterIsSelected = true;
    const currentFilter = [{ field: this.columnDef, operator: this.operator.value, value: this.value.value }];
    this.filterChange.emit(currentFilter);
  }
}
